import { useCallback } from 'react'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { usePage } from 'publisher/store'
import { getAscendantPopup } from 'publisher/store/page/pageSelectors'
import { setCloseCookie } from 'publisher/utils/cookie'

export function useClosePopup(
  entity: EntityInterface | OldEntityInterface,
  pageId: number,
) {
  const popup = usePage(p => getAscendantPopup(p, entity)) as
    | OldEntityInterface
    | PopupInterface
    | undefined

  return useCallback(() => {
    if (popup) {
      setCloseCookie(
        pageId,
        popup.id,
        popup.type === EntityTypeEnum.Popup
          ? popup?.closedDays
          : popup?.options?.closedDays,
      )
    }
  }, [pageId, popup])
}
